var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../di";
import { Availability } from "./Availability";
import { PurchaseOrderPayload } from "./PurchaseOrderPayload";
import { Restaurant } from "./Restaurant";
let AgeVerificationService = class AgeVerificationService {
    constructor(payload, restaurant) {
        this.payload = payload;
        this.restaurant = restaurant;
        this.isChecked = false;
        makeAutoObservable(this);
    }
    get isRequired() {
        if (this.payload.isEmpty)
            return false;
        return this.payload.orderLines.some((orderLine) => {
            // Product or category level
            const isProductAgeRestricted = orderLine.productTypeIds.some((id) => { var _a, _b; return (_b = (_a = this.restaurant.menu.productTypes.find(id)) === null || _a === void 0 ? void 0 : _a.ageRestricted) !== null && _b !== void 0 ? _b : false; });
            // Modifier or modifier item level
            const isModifierAgeRestricted = orderLine.productInstance.modifierInstances.some((modifierInstance) => {
                if (modifierInstance.modifierType.ageRestricted)
                    return true;
                return modifierInstance.selectedItems.some((item) => item.modifierItemType.ageRestricted);
            });
            return isProductAgeRestricted || isModifierAgeRestricted;
        });
    }
    get availability() {
        if (!this.isRequired)
            return Availability.available();
        return Availability.boolean({
            AgeVerificationRequired: !this.isChecked,
        });
    }
};
AgeVerificationService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof PurchaseOrderPayload !== "undefined" && PurchaseOrderPayload) === "function" ? _a : Object, typeof (_b = typeof Restaurant !== "undefined" && Restaurant) === "function" ? _b : Object])
], AgeVerificationService);
export { AgeVerificationService };
